<template>
  <div class="details_form_item">
    <Form ref="detailModel" :model="detailModel" :label-width="130">
      <FormItem label="机构名称：" prop="organName">{{
        detailModel.organName
      }}</FormItem>
      <FormItem label="机构编号：" prop="organCode">{{
        detailModel.organCode
      }}</FormItem>
      <FormItem label="机构英文名称：">{{ detailModel.organNameEN }}</FormItem>
      <FormItem label="机构类型：">{{ organTypeName }}</FormItem>
      <FormItem label="机构电话：">{{ detailModel.organTell }}</FormItem>
      <FormItem label="机构地址：">{{ detailModel.organAddress }}</FormItem>
      <FormItem label="经度：">{{ detailModel.organLongitude }}</FormItem>
      <FormItem label="纬度：">{{ detailModel.organLatitude }}</FormItem>
      <FormItem label="上级机构名称：">{{detailModel.organParentName}}</FormItem>
      <FormItem label="备注：">{{ detailModel.remark }}</FormItem>
      <FormItem label="行政区：">
        <v-region-text
          separator="-"
          v-model="address"
        ></v-region-text>
      </FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentId"],
  data: function () {
    return {
      address: {
        province: "",
        city: "",
        area: "",
        town: "",
      },
      organTypeName:'',
      detailModel: {},
    };
  },

  created: function () {
    this.initData(this.currentId);
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
    initData(id) {
      this.$api.get(`organ/GetById?id=${id}`).then((rsp) => {
        if (rsp != false) {
          this.detailModel = rsp.data.item1;
          this.organTypeName=rsp.data.item2
          this.address.province = this.detailModel.province;
          this.address.city = this.detailModel.city;
          this.address.area = this.detailModel.area;
          this.address.town = this.detailModel.town;
        }
      });
    },
  },
};
</script>
<style scoped>
</style>